import { defineMessage } from "react-intl";

import {
    SoftwareTabContent,
    ProductManagementTabContent,
    MarketingTabContent,
    ProjectManagementTabContent,
    DesignTabContent,
    ITTabContent
} from "./index";

// put data for default state into hero component file

type TeamType =
    | "default"
    | "software"
    | "product-management"
    | "marketing"
    | "project-management"
    | "design"
    | "it";

type Team = {
    id: TeamType;
    icon: string;
    iconHover: string;
    videoLink?: string;
    heroImage: string;
    title: {
        id: string;
        defaultMessage: string;
    };
    englishLabel: string;
    tabComponent: React.ReactNode | (() => React.ReactNode);
};

const TEAM_DATA: Team[] = [
    {
        id: "software",
        icon: "https://wac-cdn.atlassian.com/misc-assets/webp-images/software.svg",
        iconHover:
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/software-hover.svg",
        heroImage:
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Jira-Board-Software-3233077719.webp",
        title: defineMessage({
            id: "HomePageTemplateV2.tabsSection.label.tab1",
            defaultMessage: "Software"
        }),
        englishLabel: "Software",
        tabComponent: SoftwareTabContent
    },
    {
        id: "product-management",
        icon: "https://wac-cdn.atlassian.com/misc-assets/webp-images/prod-management.svg",
        iconHover:
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/prod-management-hover.svg",
        heroImage:
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Jira-Timeline-Product Management-3301759489.webp",
        title: defineMessage({
            id: "HomePageTemplateV2.tabsSection.label.tab2",
            defaultMessage: "Product management"
        }),
        englishLabel: "Product management",
        tabComponent: ProductManagementTabContent
    },
    {
        id: "marketing",
        icon: "https://wac-cdn.atlassian.com/misc-assets/webp-images/marketing.svg",
        iconHover:
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/marketing-hover.svg",
        heroImage:
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Jira-Calendar-Marketing-4146978900.webp",
        title: defineMessage({
            id: "HomePageTemplateV2.tabsSection.label.tab3",
            defaultMessage: "Marketing"
        }),
        englishLabel: "Marketing",
        tabComponent: MarketingTabContent
    },
    {
        id: "project-management",
        icon: "https://wac-cdn.atlassian.com/misc-assets/webp-images/proj-management.svg",
        iconHover:
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/proj-management-hover.svg",
        heroImage:
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Jira-Timeline-Project Management-2679766879.webp",
        title: defineMessage({
            id: "HomePageTemplateV2.tabsSection.label.tab4",
            defaultMessage: "Project management"
        }),
        englishLabel: "Project management",
        tabComponent: ProjectManagementTabContent
    },
    {
        id: "design",
        icon: "https://wac-cdn.atlassian.com/misc-assets/webp-images/design.svg",
        iconHover:
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/design-hover.svg",
        heroImage:
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Jira-List-Design-1069502226.webp",
        title: defineMessage({
            id: "HomePageTemplateV2.tabsSection.label.tab5",
            defaultMessage: "Design"
        }),
        englishLabel: "Design",
        tabComponent: DesignTabContent
    },
    {
        id: "it",
        icon: "https://wac-cdn.atlassian.com/misc-assets/webp-images/it.svg",
        iconHover:
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/it-hover.svg",
        heroImage:
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Jira-On-call-IT-3030871761.webp",
        title: defineMessage({
            id: "HomePageTemplateV2.tabsSection.label.tab6",
            defaultMessage: "IT"
        }),
        englishLabel: "IT",
        tabComponent: ITTabContent
    }
];

export { TEAM_DATA, Team };
